<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();
</script>

<template>
    <radio-group-inline
        label="Content width"
        name="portal_signup_sidebar_width"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_signup_sidebar_width"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_signup_sidebar_width = $event"
        :options="[
            { value: 'lg:w-5/12', label: 'Narrow'},
            { value: 'lg:w-6/12', label: 'Regular'},
            { value: 'lg:w-8/12', label: 'Wide'}
        ]"
    >
    </radio-group-inline>

    <radio-group-inline
        label="Sidebar"
        name="portal_signup_sidebar_side"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_signup_sidebar_side"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_signup_sidebar_side = $event"
        :options="[
            { value: 'left', label: 'Right'},
            { value: 'right', label: 'Left'},
            { value: 'none', label: 'None'}
        ]"
    >
    </radio-group-inline>

    <file-upload
        v-if="portalContentAndDesignStore.portalLayoutSettings.portal_signup_sidebar_side !== 'none'"
        :src="portalContentAndDesignStore.srcRoutes.portal_signup_file_background"
        @update:src="portalContentAndDesignStore.srcRoutes.portal_signup_file_background = $event"
        no_src="https://app.partnero.com/images/bg.png"
        accept="image/*"
        title="Sidebar image"
        name="portal_signup_file_background"
        :upload_url="portalContentAndDesignStore.getFileUploadRoute"
        :delete_url="portalContentAndDesignStore.getFileDeleteRoute">
        ></file-upload>
</template>

